export default __webpack_public_path__ + "63cca2c8cfecd8d4cb91d06d6c923bab.png";